import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../fonts/euclidCircular-b-regular.woff%22}],%22variableName%22:%22euclidCircularBRegular%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'euclidCircularBRegular', 'euclidCircularBRegular Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
